import {CLStore} from 'common/src/redux/store';
import {z} from 'zod';
import {AgentName, LLMResponseType} from '../copilot.enums';
import {plaintextPartSchema} from '../copilot.schemas';
import {Agent} from '../copilot.types';
import getLLMModel from '../models/utils/getLLMModel';
import {OpenAIModel} from '../openAI/openAI.enums';
import buildAgentInstructions from '../skills__invokeAgent/utils/buildAgentInstructions';
import agentBase from '../utils/creators/agentBase';

export default function skillsAgent(store: CLStore): Agent {
  const instructions = buildAgentInstructions();

  const responseSchema = z.object({
    type: z
      .literal(LLMResponseType.Content)
      .describe(`A '${LLMResponseType.Content}' type of response`),
    parts: z.array(plaintextPartSchema),
  });

  const agentBaseObject = agentBase({
    name: AgentName.General,
    role: 'You are Copilot, an intelligent assistant in the Flight Control product.',
    instructions,
    model: getLLMModel(OpenAIModel.Gpt5_2),
    responseSchema,
  });

  return {
    ...agentBaseObject,
    name: AgentName.General,
    scope: {inScope: [], outOfScope: []},
    __DEPRECATED_uiToolNames: [],
    contexts: [],
    store,
    conversationStarters: [],
  };
}
